import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Spin } from "antd";
import { GetUsuariIdActivitats } from "../../../../dao/GetUsuariIdActivitats";
import ActivitatAlumnesBbddModal from "../../problemes/content/ActivitatAlumnesBbddModal";

const ActivitatsIdAlumnes: React.FC = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_activitat } = useParams<{ id_activitat: string }>();
    const navigate = useNavigate();

    // Només professors (0) i admins (1) poden veure el seguiment d'alumnes. Un alumne (tipus 2)
    // que hi accedeixi per URL és redirigit a la vista d'exercicis, que sí pot veure.
    const isTeacher = user?.tipus === "0" || user?.tipus === "1";

    const [loading, setLoading] = useState(true);
    const [activitatObj, setActivitatObj] = useState<any>(null);

    useEffect(() => {
        if (isLoggedIn && user && !isTeacher) {
            navigate(`/database/activitats/${id_activitat}`, { replace: true });
        }
    }, [isLoggedIn, user, isTeacher, id_activitat]);

    useEffect(() => {
        if (isLoggedIn && id_activitat && isTeacher) {
            loadActivitat();
        }
    }, [id_activitat, isLoggedIn, userId, isTeacher]);

    async function loadActivitat() {
        setLoading(true);
        try {
            const prac = await GetUsuariIdActivitats(userId);
            const actividad = (prac || []).find((act: any) => String(act.id) === String(id_activitat));
            const obj = actividad || { id: Number(id_activitat), nom: `Activitat ${id_activitat}` };
            setActivitatObj(obj);

            const nom = obj?.nom || `Activitat ${id_activitat}`;
            setBreadCrumb([
                { nom: 'Home', nav: '/home' },
                { nom: 'database', nav: '/database' },
                { nom: 'activitats', nav: `/database/activitats` },
                { nom: nom, nav: `/database/activitats/${id_activitat}` },
                { nom: 'alumnes', nav: `/database/activitats/${id_activitat}/alumnes` }
            ], true);
        } catch (e) {
            console.error("Error carregant activitat a ActivitatsIdAlumnes:", e);
            setActivitatObj({ id: Number(id_activitat), nom: `Activitat ${id_activitat}` });
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
                <Spin size="large" tip="Carregant dades de l'activitat..." />
            </div>
        );
    }

    return (
        <ActivitatAlumnesBbddModal
            activitat={activitatObj}
            isPage={true}
            visible={true}
        />
    );
};

export default ActivitatsIdAlumnes;
